import { ActionType } from "../types/store-types";
import { objectCreatorTypes } from "./../../helpers/objectCreator";
import { IError } from "../types/errors";
/* - Data Types - */

export interface IConfig {
    stop_writing_warn: boolean;
    leave_field_warn: boolean;
    show_via_tooltip: boolean;
    show_all_errors: boolean;
}

export interface IChangeConfigData {
    path: string;
    value: objectCreatorTypes;
}

export interface IChangeConfigSuccessData {
    config: IConfig;
}

export interface IChangeConfigsFailureData extends IError {}
/* - State - */

export interface IConfigState {
    config: IConfig;
}

/* - Action Types - */

export enum ConfigActionTypes {
    CHANGE_CONFIGS_REQUEST = "CONFIGS.CHANGE_CONFIGS_REQUEST",
    CHANGE_CONFIGS_SUCCESS = "CONFIGS.CHANGE_CONFIGS_SUCCESS",
    CHANGE_CONFIGS_FAILURE = "CONFIGS.CHANGE_CONFIGS_FAILURE",
    INIT_CONFIGS = "CONFIGS.INIT_CONFIGS",
}

/* - Action Interfaces  - */

export type InitConfigActionType = ActionType<ConfigActionTypes.INIT_CONFIGS, IChangeConfigSuccessData>;

export type ChangeConfigActionType = ActionType<ConfigActionTypes.CHANGE_CONFIGS_REQUEST, IChangeConfigData>;

export type ChangeConfigSuccessActionType = ActionType<
    ConfigActionTypes.CHANGE_CONFIGS_SUCCESS,
    IChangeConfigSuccessData
>;
export type ChangeConfigFailureActionType = ActionType<
    ConfigActionTypes.CHANGE_CONFIGS_FAILURE,
    IChangeConfigsFailureData
>;
